import React from "react";
import moment from "moment-jalaali";
import {useHistory} from "react-router-dom";

function OfflineCard({item}) {

    const history = useHistory()

    function numberWithCommas  (x) {
        if (x === 0) {
            return 0
        }
        if(x){
            x= Math.round(x)
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        }

        return "-"

    }

    const ConvertTMonthName = (month) =>{
        let name= "";
        switch (month) {
            case '01':
                name =  "فروردین";
                break;
            case '02':
                name =  "اردیبهشت";
                break;
            case '03':
                name =  "خرداد";
                break;
            case '04':
                name =  "تیر";
                break;
            case '05':
                name =  "مرداد";
                break;
            case '06':
                name =  "شهریور";
                break;
            case '07':
                name =  "مهر";
                break;
            case '08':
                name =  "آبان";
                break;
            case '09':
                name =  "آذر";
                break;
            case '10':
                name =  "دی";
                break;
            case '11':
                name =  "بهمن";
                break;
            case '12':
                name =  "اسفند";
                break;
            default:
                name =  "---";
        }

        return name;
    }


    const dateConvertor = (date)=>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]).format('jDD');
            let hh = moment.utc(date.split('+')[0]).format('HH');
            let mm = moment.utc(date.split('+')[0]).format('mm');
            return day+" "+month+""+year+" - "+hh+":"+mm
        }else {
            return "-/-/-  -:-"
        }
    }

    const statusConvertor = (code) =>{

        let result =""
        switch (code) {
            case 1:
                result  =  "اولیه"
                break;
            case 2:
                result  =  "آماده پرداخت"
                break;
            case 3:
                result  =  "نهایی شده توسط مشتری"
                break;
            case 5:
                result  =  "رد شده توسط صندوقدار"
                break;
            case 13:
                result  =  "آماده ارسال"
                break;
            case 20:
                result  =  "قبول کردن"
                break;
            case 25:
                result  =  "تحویل شده"
                break;
            case 9:
                result  =  "شروع جمع آوری"
                break;
            case 10:
                result  =  "جمع آوری شده"
                break;
            case 15:
                result  =  "ادامه"
                break;
            case 30:
                result  =  "توسط مشتری لغو شد"
                break;
        }

        return result;


    }

    return(
        <div className="onlineCard-container" onClick={()=>{
            history.push(`/invoice-detail/${item.uid}`)
        }}>
            <div className="onlineCard-price">
                <i className="fa fa-angle-left"></i>
                <span>ریال</span>
                <span>{numberWithCommas(item.amount)}</span>
            </div>
            <div className="onlineCard-info">
                <div className="title">{item.merchant.name}</div>
                <div className="status">{statusConvertor(item.status)}</div>
                <div className="date">{dateConvertor(item.created)}</div>
            </div>

        </div>
    )
}

export {OfflineCard}
